__turbopack_context__.v({
  "close-button": "ContactForm-module__fw3Taq__close-button",
  "contact-form": "ContactForm-module__fw3Taq__contact-form",
  "custom-container": "ContactForm-module__fw3Taq__custom-container",
  "error-input": "ContactForm-module__fw3Taq__error-input",
  "error-label": "ContactForm-module__fw3Taq__error-label",
  "error-message": "ContactForm-module__fw3Taq__error-message",
  "error-submit": "ContactForm-module__fw3Taq__error-submit",
  "field-wrapper": "ContactForm-module__fw3Taq__field-wrapper",
  "form-footer": "ContactForm-module__fw3Taq__form-footer",
  "input": "ContactForm-module__fw3Taq__input",
  "label": "ContactForm-module__fw3Taq__label",
  "popover": "ContactForm-module__fw3Taq__popover",
  "popover-container": "ContactForm-module__fw3Taq__popover-container",
  "privacy": "ContactForm-module__fw3Taq__privacy",
  "select": "ContactForm-module__fw3Taq__select",
  "select-item": "ContactForm-module__fw3Taq__select-item",
  "submit-button": "ContactForm-module__fw3Taq__submit-button",
  "success-submit": "ContactForm-module__fw3Taq__success-submit",
});
